import { render, staticRenderFns } from "./resureDialog.vue?vue&type=template&id=2406fd64&scoped=true&"
import script from "./resureDialog.vue?vue&type=script&lang=js&"
export * from "./resureDialog.vue?vue&type=script&lang=js&"
import style0 from "./resureDialog.vue?vue&type=style&index=0&id=2406fd64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2406fd64",
  null
  
)

export default component.exports